/* modified by Glamojo */

if (!window.GlamojoAnnouncementInitialized) {
	window.GlamojoAnnouncementInitialized = true;

	(() => {
		const animationClasses = [
			'animate__fadeIn',
			'animate__fadeInUp',
			'animate__fadeInDown',
			'animate__fadeInLeft',
			'animate__fadeInRight',
			'animate__flipInX',
			'animate__flip',
			'animate__zoomOut',
			'animate__zoomIn'
		];

		const hasReducedMotion = () => {
			return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		};

		const isDocumentHidden = () => {
			return typeof document.hidden !== 'undefined' && document.hidden;
		};

		const initAnnouncementRotator = (section) => {
			if (!section || section.dataset.glamojoInit === 'true') return;

			const rotator = section.querySelector('[data-glamojo-announcement]');
			if (!rotator) return;

			const items = Array.from(rotator.querySelectorAll('.glamojo-announcement-item'));
			const closeButton = section.querySelector('[data-glamojo-announcement-close]');

			if (items.length === 0) return;

			section.dataset.glamojoInit = 'true';

			let currentIndex = 0;
			let timer = null;
			const autoplay = rotator.dataset.autoplay === 'true';
			const parsedSpeed = parseInt(rotator.dataset.speed || '4000', 10);
			const speed = Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : 4000;
			const animationType = rotator.dataset.animation || 'fadeIn';
			const reduceMotion = hasReducedMotion();

			const animateItem = (item) => {
				if (animationType === 'none' || reduceMotion) return;

				const animationClass = `animate__${animationType}`;
				if (!animationClasses.includes(animationClass)) return;

				item.classList.remove('animate__animated', ...animationClasses);
				void item.offsetWidth;
				item.classList.add('animate__animated', animationClass);
			};

			const showItem = (index, withAnimation = true) => {
				items.forEach((item, itemIndex) => {
					const isActive = itemIndex === index;
					item.classList.toggle('is-active', isActive);
					item.hidden = !isActive;

					if (!isActive) {
						item.classList.remove('animate__animated', ...animationClasses);
					}
				});

				currentIndex = index;

				if (withAnimation && items[index]) {
					animateItem(items[index]);
				}
			};

			const startAutoplay = () => {
				if (!autoplay || items.length < 2) return;

				stopAutoplay();
				timer = window.setInterval(() => {
					const nextIndex = (currentIndex + 1) % items.length;
					showItem(nextIndex, true);
				}, speed);
			};

			const stopAutoplay = () => {
				if (timer) {
					window.clearInterval(timer);
					timer = null;
				}
			};

			const handleVisibilityChange = () => {
				if (isDocumentHidden()) {
					stopAutoplay();
				} else {
					startAutoplay();
				}
			};

			const handleCloseClick = () => {
				stopAutoplay();
				document.removeEventListener('visibilitychange', handleVisibilityChange);
				document.removeEventListener('shopify:section:unload', handleSectionUnload);

				if (closeButton) {
					closeButton.removeEventListener('click', handleCloseClick);
				}

				const sectionWrapper = section.closest('.shopify-section');
				if (sectionWrapper) sectionWrapper.remove();
			};

			const handleSectionUnload = (event) => {
				if (event.target !== section && !event.target.contains(section)) return;

				stopAutoplay();
				document.removeEventListener('visibilitychange', handleVisibilityChange);
				document.removeEventListener('shopify:section:unload', handleSectionUnload);

				if (closeButton) {
					closeButton.removeEventListener('click', handleCloseClick);
				}

				section.dataset.glamojoInit = 'false';
			};

			if (closeButton) {
				closeButton.addEventListener('click', handleCloseClick);
			}

			if (autoplay && items.length > 1) {
				document.addEventListener('visibilitychange', handleVisibilityChange);
			}

			document.addEventListener('shopify:section:unload', handleSectionUnload);

			showItem(0, false);

			if (!isDocumentHidden()) {
				startAutoplay();
			}
		};

		const initAllAnnouncementRotators = () => {
			document.querySelectorAll('.glamojo-announcement-bar').forEach((section) => {
				initAnnouncementRotator(section);
			});
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initAllAnnouncementRotators);
		} else {
			initAllAnnouncementRotators();
		}

		document.addEventListener('shopify:section:load', (event) => {
			initAnnouncementRotator(event.target);
		});
	})();
}